/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"
import { InflationSurchargeFragmentDoc } from "./fragment.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type InflationSurchargeQueryVariables = Exact<{ [key: string]: never }>

export type InflationSurchargeQuery = {
  __typename: "Query"
  inflationSurcharge: {
    __typename: "InflationSurcharge"
    value?: number | null
  }
}

export const InflationSurchargeDocument = gql`
  query InflationSurcharge {
    inflationSurcharge
      @rest(type: "InflationSurcharge", path: "/price/inflation-surcharge") {
      ...InflationSurcharge
    }
  }
  ${InflationSurchargeFragmentDoc}
`

/**
 * __useInflationSurchargeQuery__
 *
 * To run a query within a React component, call `useInflationSurchargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInflationSurchargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInflationSurchargeQuery({
 *   variables: {
 *   },
 * });
 */
export function useInflationSurchargeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >(InflationSurchargeDocument, options)
}
export function useInflationSurchargeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >(InflationSurchargeDocument, options)
}
// @ts-ignore
export function useInflationSurchargeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  InflationSurchargeQuery,
  InflationSurchargeQueryVariables
>
export function useInflationSurchargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InflationSurchargeQuery,
        InflationSurchargeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  InflationSurchargeQuery | undefined,
  InflationSurchargeQueryVariables
>
export function useInflationSurchargeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InflationSurchargeQuery,
        InflationSurchargeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InflationSurchargeQuery,
    InflationSurchargeQueryVariables
  >(InflationSurchargeDocument, options)
}
export type InflationSurchargeQueryHookResult = ReturnType<
  typeof useInflationSurchargeQuery
>
export type InflationSurchargeLazyQueryHookResult = ReturnType<
  typeof useInflationSurchargeLazyQuery
>
export type InflationSurchargeSuspenseQueryHookResult = ReturnType<
  typeof useInflationSurchargeSuspenseQuery
>
export type InflationSurchargeQueryResult = Apollo.QueryResult<
  InflationSurchargeQuery,
  InflationSurchargeQueryVariables
>
